import type React from "react";
import { useTranslation } from "../hooks/useTranslation";

interface SearchBarProps {
	searchTerm: string;
	setSearchTerm: (term: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, setSearchTerm }) => {
	const t = useTranslation();

	return (
		<div className="mb-5 mt-2 mx-0.5 relative">
			<span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 text-base">🔍</span>
			<input
				type="text"
				className="w-full rounded-lg bg-gray-100 border border-gray-300/60 text-gray-800 pl-12 pr-10 py-3 text-base placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-transparent shadow-sm transition-colors dark:bg-gray-700/50 dark:border-gray-600/50 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500/50"
				placeholder={t.searchPlaceholder}
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
			/>
			{searchTerm && (
				<button
					type="button"
					className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer transition-colors border-none bg-transparent p-1 dark:text-gray-400 dark:hover:text-gray-200"
					onClick={() => setSearchTerm("")}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							setSearchTerm("");
						}
					}}
					aria-label={t.clearSearch}
				>
					✕
				</button>
			)}
		</div>
	);
};

export default SearchBar;
